module.exports = __webpack_public_path__ + "static/media/agentInfo.4645bd76.png";